module.exports = __webpack_public_path__ + "img/prioritas_vippack_dfod_k.81ee1255.png";